export default __webpack_public_path__ + "static/media/log_out.db4c2627.svg";